import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

const Main = () => {
  return (
    <section className="py-5 bg-white main-section">
      <Container style={{ maxWidth: "80%" }}>
        <motion.h2
          className="fw-bold text-center mb-5"
          style={{
            color: "#ff6700",
            fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" }
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          ¿Quiénes Somos?
        </motion.h2>

        <Row className="align-items-center">
          <Col xs={12} md={6} className="mb-4 mb-md-0 text-center">
            <motion.img
              src={require("../../static/media/aboutUs/main.webp")}
              alt="Quiénes somos - CMSOLTEC"
              className="img-fluid main-img"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            />
          </Col>

          <Col xs={12} md={6}>
            <motion.p
              className="main-text"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              Con sede en Quito, Ecuador y más de dos décadas de experiencia, 
              CMSOLTEC ha sido un aliado estratégico en soluciones tecnológicas 
              para clientes individuales, profesionales y pequeñas empresas. 
            </motion.p>

            <motion.p
              className="main-text"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              En nuestro proceso de expansión, orientamos nuestros esfuerzos hacia el sector 
              corporativo, ofreciendo infraestructura, asesoría y soporte especializado en tecnologías 
              de la información y comunicación. Nuestra trayectoria nos respalda como una organización 
              sólida, confiable y comprometida con la excelencia.
            </motion.p>
          </Col>
        </Row>
        <motion.h3
          className="fw-bold text-center mb-5"
          style={{
            color: "#ff6700",
            fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
            marginTop: "2rem",
          }}
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          Compromiso CMSOLTEC
        </motion.h3>
        <motion.p
              className="main-text"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              En CMSOLTEC, cada servicio es una promesa de calidad. Nuestra prioridad es 
              establecer relaciones duraderas con nuestros clientes, ofreciendo asesoría experta, 
              soporte continuo y soluciones tecnológicas que impulsen su desarrollo. Creemos en la 
              mejora constante, la innovación y la confianza como pilares de nuestro crecimiento conjunto.
            </motion.p>
      </Container>

      <style>
        {`
          .main-section h2 {
            font-size: 1.5rem;
          }
          .main-section .main-text {
            font-size: 1rem;
            line-height: 1.7;
            color: #444;
            text-align: justify;
          }
          @media (min-width: 576px) {
            .main-section h2 {
              font-size: 1.8rem !important;
            }
            .main-section .main-text {
              font-size: 1.125rem !important;
            }
            .main-section .main-img {
              max-width: 50% !important;
            }
          }
          @media (min-width: 992px) {
            .main-section h2 {
              font-size: 2.3rem !important;
            }
            .main-section .main-text {
              font-size: 1.25rem !important;
            }
            .main-section .main-img {
              max-width: 60% !important;
            }
          }
          @media (max-width: 576px) {
            .main-section .main-img {
              max-width: 70% !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Main;
